// Generated by scripts/mdi/import-questionnaires.mjs from MDI "1. Glutathione Initial 6/1/26 09.17.26" (f998bb0c-2eb3-4e8b-9cc8-2fdcc74dacf9). Re-run instead of editing.
import { FormType } from '../../../form-types';
import { mdiGlutathioneInitialAnswerField } from './questions';

export const mdiGlutathioneInitial: FormType<mdiGlutathioneInitialAnswerField> =
  {
    name: 'Glutathione Initial',
    validityLength: 25,
    questions: [
      {
        key: 'mdiGlutathioneInitial_sex',
        next: {
          switch: [
            {
              condition: { 'mdiGlutathioneInitial_sex.female': true },
              key: 'mdiGlutathioneInitial_pregnantBreastfeeding'
            },
            {
              condition: {
                'mdiGlutathioneInitial_pregnantBreastfeeding.currently_pregnant':
                  true
              },
              key: 'mdiGlutathioneInitial_urgentDuePregnancyBreastfeedingCannot'
            },
            {
              condition: {
                'mdiGlutathioneInitial_pregnantBreastfeeding.currently_breastfeeding':
                  true
              },
              key: 'mdiGlutathioneInitial_urgentDuePregnancyBreastfeedingCannot'
            },
            {
              condition: {
                'mdiGlutathioneInitial_pregnantBreastfeeding.planning_to_become_pregnant_within_90_da':
                  true
              },
              key: 'mdiGlutathioneInitial_urgentDuePregnancyBreastfeedingCannot'
            }
          ],
          els: 'mdiGlutathioneInitial_reasonSeekingTreatmentGlutathione'
        }
      },
      {
        key: 'mdiGlutathioneInitial_pregnantBreastfeeding',
        next: {
          switch: [
            {
              condition: {
                'mdiGlutathioneInitial_pregnantBreastfeeding.currently_pregnant':
                  true
              },
              key: 'mdiGlutathioneInitial_urgentDuePregnancyBreastfeedingCannot'
            },
            {
              condition: {
                'mdiGlutathioneInitial_pregnantBreastfeeding.currently_breastfeeding':
                  true
              },
              key: 'mdiGlutathioneInitial_urgentDuePregnancyBreastfeedingCannot'
            },
            {
              condition: {
                'mdiGlutathioneInitial_pregnantBreastfeeding.planning_to_become_pregnant_within_90_da':
                  true
              },
              key: 'mdiGlutathioneInitial_urgentDuePregnancyBreastfeedingCannot'
            }
          ],
          els: 'mdiGlutathioneInitial_reasonSeekingTreatmentGlutathione'
        }
      },
      'mdiGlutathioneInitial_urgentDuePregnancyBreastfeedingCannot',
      'mdiGlutathioneInitial_reasonSeekingTreatmentGlutathione',
      'mdiGlutathioneInitial_historyKidneyDisease',
      'mdiGlutathioneInitial_importantClickAttachedLinkReview',
      'mdiGlutathioneInitial_elseLikeTellDoctorWho',
      'mdiGlutathioneInitial_complete'
    ]
  };
